module.exports = __webpack_public_path__ + "common/icon-arrow-87be9c8c907571dfe6b6f4a816d2b210.svg";